module.exports = __webpack_public_path__ + "3526019fd47cb673fd747eb83ac1ebb1.fbx";